import React from 'react';
import { NavMainItems } from '../../../../types/working-model';
import Icon, { ICONS } from '../../../general-ui/icon';

export const getMainNavIcon = (name: NavMainItems | string, size = 24): React.ReactElement | undefined => {
	switch (name) {
		case NavMainItems.Home:
			return React.createElement(Icon, { name: ICONS.HOME, color: '', size });
		case NavMainItems.Sessions:
		case NavMainItems.Session:
			return React.createElement(Icon, { name: ICONS.TV_WATCH, color: '', size });
		case NavMainItems.Directory:
		case NavMainItems.People:
			return React.createElement(Icon, { name: ICONS.PEOPLE_NAV, color: '', size });
		case NavMainItems.Leaderboard:
			return React.createElement(Icon, { name: ICONS.LEADERBOARD_NAV, color: '', size });
		case 'Logout':
			return React.createElement(Icon, { name: ICONS.LOG_OUT, color: '', size });
	}
};

// Re-export component exports from the .tsx file so that imports resolving to this
// .ts module (which takes priority over .tsx in TypeScript's resolution) still work.
export { default, MarketingNavMenu, NavItem } from './marketing-nav.tsx';
